export default __webpack_public_path__ + "static/media/city_img_brisbane.65c28bfc.png";